
document.addEventListener('DOMContentLoaded', function () {
        let staffSlider = document.querySelectorAll('.homeStaffSlide');
        if (staffSlider) {
            Object.keys(staffSlider).forEach((ele) => {
                //console.log(staffSlider);
                var staffSplide = new Splide(staffSlider[ele], {
                    gap: 6,
                    arrows: false,
                    pagination: false,
                    arrowPath: 'm13.4 8.4c0.6-0.5 1.6-0.5 2.2 0l10.5 10.6c0.6 0.6 0.6 1.5 0 2.1l-10.5 10.5c-0.6 0.6-1.6 0.6-2.2 0-0.5-0.6-0.5-1.5 0-2.1l9.5-9.5-9.5-9.4c-0.5-0.6-0.5-1.6 0-2.2z',
                    fixedWidth: 213,
                    focus: 'center',
                    mediaQuery: 'min',
                    breakpoints: {
                        768: {
                            gap: 20,
                            omitEnd: true,
                            arrows: true,
                            focus: 0,
                        }
                    }
                });
                staffSplide.mount();
            })
        }

        let splideReview = document.querySelector('.splideReview');
        if (splideReview) {
            var reviewSplide = new Splide(splideReview, {
                gap: 10,
                arrows: false,
                pagination: true,
                mediaQuery: 'min',
                classes: {
                    pagination: 'splide__pagination position-relative bottom-0 mt-4',
                    page: 'splide__pagination--page border-0 rounded-circle mx-1',
                },
                breakpoints: {
                    1200: {
                        gap: 33,
                    },
                    992: {
                        perPage: 3,
                    },
                    576: {
                        perPage: 2,
                    }
                }
            });
            reviewSplide.mount();
        }

        let megazine = document.querySelector('.splideMagazine');
        if (megazine) {
            var megazineSlide = new Splide(megazine, {
                gap: 10,
                arrows: false,
                pagination: false,
                destroy: false,
                fixedWidth: '313px',
                mediaQuery: 'min',
                padding: 18,
                breakpoints: {
                    992: {
                        destroy: true,
                    }
                }
            });
            megazineSlide.mount();
        }

        const recomended = document.querySelector('.recommended-slider');
        //console.log(recomended);
        if (recomended) {
            let splide = new Splide(recomended, {
                pagination: false,
                trimSpace: 'move',
                focus    : 'center',
                arrows: false,
                padding: '0rem',
                gap: '3px',
                arrowPath: 'm13.4 8.4c0.6-0.5 1.6-0.5 2.2 0l10.5 10.6c0.6 0.6 0.6 1.5 0 2.1l-10.5 10.5c-0.6 0.6-1.6 0.6-2.2 0-0.5-0.6-0.5-1.5 0-2.1l9.5-9.5-9.5-9.4c-0.5-0.6-0.5-1.6 0-2.2z',
                //fixedHeight: '377px',
                fixedWidth: 213,
                mediaQuery: 'min',
                breakpoints: {
                    576: {
                        gap: '8px',
                        // fixedHeight: '300px',
                        // fixedWidth: '180px',
                        omitEnd: true,
                    },
                    // 768: {
                    //     // fixedHeight: '350px',
                    //     // fixedWidth: '258px',
                    //     //arrows: true,
                    // },
                    992: {
                        // fixedHeight: '450px',
                        fixedWidth: '255px',
                        gap: '14px',
                        focus: 0,

                    },
                    1200: {
                        padding: '2rem',
                    },
                    // 1400: {
                    //     fixedHeight: '440px',
                    // },
                },
                // classes: {
                //     pagination: 'splide__pagination position-relative mt-3', // container
                //     page      : 'splide__pagination__page',
                //     arrows: 'splide__arrows position-absolute d-flex splide-arrows--top end-0',
                //     arrow : 'splide__arrow position-relative bg-transparent border border-black rounded-circle transform-0',
                //     prev  : 'splide__arrow--prev your-class-prev start-0',
                //     next  : 'splide__arrow--next your-class-next  end-0 ms-2',
                // },
            });

            splide.mount();
            function video() {
                const videosContainer = document.querySelectorAll('.recommended-slider .splide__slide');
                const isMobile = window.matchMedia('(max-width: 991px)').matches;
                let videoElement = null;

                const createVideo = (videoUrl) => {
                    if (!videoElement) {
                        videoElement = document.createElement('video');
                        videoElement.autoplay = true;
                        videoElement.playsInline = true;
                        videoElement.muted = true;
                        videoElement.loop = true;
                        videoElement.controls = false;
                    }
                    videoElement.src = videoUrl;
                };



                if (isMobile) {
                    splide.on('active', (slide) => {
                        if (slide.slide.dataset.video) {
                            createVideo(slide.slide.dataset.video);
                            slide.slide.querySelector('.media-holder').appendChild(videoElement);
                        }
                    });

                    splide.on('inactive', (slide) => {
                        if (slide.slide.querySelector('.media-holder video')) {
                            slide.slide.querySelector('.media-holder video').remove();
                            videoElement = null;
                        }
                    });
                    // Autoplay video in the first slide when mobile
                    const firstSlide = recomended.querySelector('.splide__slide.is-active');
                    if (firstSlide) {
                        createVideo(firstSlide.dataset.video);
                        firstSlide.querySelector('.media-holder').appendChild(videoElement);
                    }
                } else {
                    videosContainer.forEach((videoSlide) => {
                        videoSlide.addEventListener('mouseenter', (e) => {
                            if (videoSlide.dataset.video) {
                                createVideo(videoSlide.dataset.video);
                                videoSlide.querySelector('.media-holder').appendChild(videoElement);
                            }
                        });

                        videoSlide.addEventListener('mouseleave', (e) => {
                            if (videoSlide.querySelector('.media-holder video')) {
                                videoSlide.querySelector('.media-holder video').remove();
                                videoElement = null;
                            }
                        });
                    });
                }
            }

            video();
        }
});
